// Copyright (c) Bentley Systems
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        fill="#fff"
        transform="scale(1.9) translate(5.5 5)"
        xmlns="http://www.w3.org/2000/svg"
        d="M13 0H3a1 1 0 00-1 1v14a1 1 0 001 1h10a1 1 0 001-1V1a1 1 0 00-1-1zM5 13H4v-1h1zm0-3H4V9h1zm0-3H4V6h1zm0-3H4V3h1zm7 9H7v-1h5zm0-3H7V9h5zm0-3H7V6h5zm0-3H7V3h5z"
      />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const DetailsAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {setToggle(props.isFocused);}
  }, [props]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length, // the number of springs to create
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    // use `animated.g` instead of `g` as the `animatedStyle`
    // is a special react-spring flavour of the `style` property
    <animated.g
      key={index}
      style={animatedStyle} // apply the animated style
    >
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {setToggle(true);}
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {setToggle(false);}
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default DetailsAnim;
